import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { PushNotifications, Token } from '@capacitor/push-notifications';
import { Platform } from '@ionic/angular';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { GpsLocationService } from 'shared';
import { GpsService } from '../gps/gps.service';

@Injectable({ providedIn: 'root' })
export class PushService {
  readonly apiUrl = '/api/push-notifications';

  fcmToken$ = new BehaviorSubject<string>(null);

  constructor(
    private platform: Platform,
    private gpsService: GpsService,
    private http: HttpClient,
    private gpsLocationService: GpsLocationService,
    private router: Router,
    private zone: NgZone
  ) {
    if (this.platform.is('android')) {
      this.registerPush();
    } else {
      window.addEventListener('fcmToken', (event: any) => {
        console.log('🔔 FCM Token:', event);
        this.fcmToken$.next(event.value);
      });
    }

  }

  async registerPush() {
    this.platform.ready().then(async () => {
      if (!this.platform.is('ios') && !this.platform.is('android')) {
        console.warn('❗️ Push notifications are only available on real mobile devices');
        return;
      }
      console.log('🔔 Реєстрація пушів...');
      const permStatus = await PushNotifications.requestPermissions();

      if (permStatus.receive !== 'granted') {
        console.log('❌ Доступ до push не надано');
        return;
      }

      await PushNotifications.register();


      PushNotifications.addListener('registration', (token: Token) => {
        console.log('✅ Реєстрація пушів успішна:', token.value);
        // this.saveToken(token.value).subscribe();
        this.fcmToken$.next(token.value);
      });


      PushNotifications.addListener('registrationError', err => {
        console.error('❌ Помилка реєстрації пушів:', err);
      });

      PushNotifications.addListener('pushNotificationReceived', async (notification) => {
        console.log('🔔 PUSH');

        if (notification.data?.requestLocation) {
          if (this.platform.is('android')) {

            const position = await this.gpsService.getCurrentPosition();

            this.gpsLocationService.updateLocation({
              token: this.fcmToken$.value,
              latitude: position.latitude,
              longitude: position.longitude
            }).subscribe();

          }
        }
      });

      PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
        console.log('📥 Клік по push:', action);
        // нове повідомлення в Telegram-чаті — відкриваємо цей чат
        const data = action.notification?.data;
        if (data?.type === 'telegram-chat' && data?.chatId) {
          this.zone.run(() => this.router.navigate(['/dashboard/chat', data.chatId]));
        }
      });
    });
  }


  saveToken(token: string): Observable<string> {
    return this.http.post<string>(`${this.apiUrl}/save-token/`, { token });
  }

  removeToken(token: string): Observable<void> {
    if (this.platform.is('android') || this.platform.is('ios')) {
      return this.http.delete<void>(`${this.apiUrl}/remove-token/${token}`);
    } else {
      return of(null);
    }
  }
}
